import { useMatchRoute } from '@tanstack/react-router';

export const useActiveRoute = () => {
    const matchRoute = useMatchRoute();

    return (route: string): boolean => {
        return !!matchRoute({ to: route, fuzzy: true });
    };
};
